module.exports = __webpack_public_path__ + "img/tag_black_pin.37c4f1bd.svg";